module.exports = __webpack_public_path__ + "img/tuceng5.a64bbd42.png";